import { defineMessages } from "react-intl";

export const messages = defineMessages({
  openGraphiQL: {
    id: "PDw0YN",
    defaultMessage: "Open this product in GraphiQL",
    description: "open new window button",
  },
});
